
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping-insurance",
      function () {
        return require("private-next-pages/shipping-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping-insurance"])
      });
    }
  